// Semantic purchased plans only. The server owns status/expiry and authorization.
// Keep Premium dashboard beta access separate from Pro feature inheritance.
export function hasProFeatures(plan?: string | null): boolean {
  const value = plan?.toLowerCase();
  return value === 'pro' || value === 'ultra_annual';
}

export function hasDashboardAccess(plan?: string | null): boolean {
  return hasProFeatures(plan) || ['annual', 'monthly', '3month', '6month', 'lifetime'].includes(plan?.toLowerCase() ?? '');
}

export function paidPlanLabel(plan?: string | null): string {
  if (plan?.toLowerCase() === 'ultra_annual') return 'OBDAI Ultra';
  return hasProFeatures(plan) ? 'OBDAI PRO' : 'OBDAI Premium';
}
